import ldb from '../base/lib/ldb'
import { XHR } from "../base/lib/xhr"
import { ISocialMedia } from '../components/pages/home/social-media-prices/smp-item'
import api from './api'

export default {
    async getRates(): Promise<ISocialMedia[]> {
        // const { data } = await XHR.get('/api/rates/social-media', { auth: ldb.get('DANESH_FX_ADMIN_TOKEN') })
        // const rates = JSON.parse(data)
        // return rates
        return api.request('/api/rates/social-media', 'GET')
    },
    async updateRate(data: { item: ISocialMedia, change: any, telegramShouldUpdate: boolean, details: string, title: string }) {
        // const rates = await XHR.put('/api/rates/social-media', data, { auth: ldb.get('DANESH_FX_ADMIN_TOKEN') })
        // return rates
        return api.request('/api/rates/social-media', 'PUT', data)
    },
    async updateMessage(key: string, value: string) {
        // const rates = await XHR.put('/api/rates/info', { key, value }, { auth: ldb.get('DANESH_FX_ADMIN_TOKEN') })
        // return rates
        return api.request('/api/rates/info', 'PUT', { key, value })
    },
    async getMessages() {
        // const { data } = await XHR.get('/api/rates/info', { auth: ldb.get('DANESH_FX_ADMIN_TOKEN') })
        // return JSON.parse(data)
        return api.request('/api/rates/info', 'GET')
    },

    async getDeals() {
        // const { data } = await XHR.get('/api/rates/deals', { auth: ldb.get('DANESH_FX_ADMIN_TOKEN') })
        // return JSON.parse(data)
        return api.request('/api/rates/deals', 'GET')
    },

    async updateDeal(data: { title: string, value: string, _id: string }) {
        return api.request(`/api/rates/deals/${data._id}`, 'PUT', data)
        // const rates = await XHR.put(`/api/rates/deals/${data._id}`, data, { auth: ldb.get('DANESH_FX_ADMIN_TOKEN') })
        // return rates
    }


}